import AppLayout from "@/components/layout/AppLayout";
import ContentHubWorkspace from "./components/ContentHubWorkspace";

export default function ContentHubPage() {
  return (
    <AppLayout>
      <ContentHubWorkspace />
    </AppLayout>
  );
}
